// extracted by mini-css-extract-plugin
export default {"header":"Header_header__HXQOm","link":"Header_link__xIhZh","logoWrapper":"Header_logoWrapper__1kB6E","logo":"Header_logo__UsziS"};